var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","padless":"","dark":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"ma-1 text-center text-caption",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(_vm.yearRange)+" "+_vm._s(_vm.$t("footer_rights"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }